import _tcLib from "../lib/timecode.js";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _Event2 from "../classes/event.js";
import _eol from "eol";
import _stripTags from "../functions/quill/stripTags.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
const getFormatOptions = _getFormatOptions;
const stripTags = _stripTags;
const eol = _eol;
const _Event = _Event2;
const convertToHtml = _convertToHtml;
const convertToPlainText = _convertToPlainText;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const tcLib = _tcLib;
export default {
  decode: function (input, options) {
    let events = [],
      decodingOptions = getFormatOptions(options.formatOptions),
      ccEvent,
      endEventFlag = false,
      lines = [],
      line = "",
      singleWord = false,
      ccAdded = false,
      maximumChars = decodingOptions["Max Characters Per Line"] ? decodingOptions["Max Characters Per Line"] : 32,
      maxLines = decodingOptions["Max Lines Per Event"] ? decodingOptions["Max Lines Per Event"] : 2,
      splitOnComma = decodingOptions["Split On Comma"] || "no",
      splitOnPunctuation = decodingOptions["Split On Punctuation"] || "no",
      blockImport = decodingOptions["Block Import"] || "no",
      cps = decodingOptions["Reading Rate"] ? decodingOptions["Reading Rate"] : 20;
    let paragraphs = eol.lf(input).split("\n\n");
    while (paragraphs && paragraphs.length > 0) {
      let paragraph = paragraphs.shift();
      if (blockImport === "yes") {
        ccEvent = new _Event();
        ccEvent.text = convertToHtml(paragraph);
        events.push(ccEvent);
        continue;
      }
      paragraph = paragraph.split("\n");
      while (paragraph && paragraph.length > 0) {
        ccAdded = false;
        let words = paragraph.shift().split(" ");
        if (words.length === 1) {
          singleWord = true;
        } else {
          singleWord = false;
        }
        ccEvent = new _Event();
        line = "";
        lines = [];
        while (words.length > 0) {
          let word = words.shift();
          if (line.length + word.length > maximumChars) {
            lines.push(line);
            line = word;
          } else {
            line += " " + word;
          }

          //console.log(lines.length, maxLines);
          if (lines.length === maxLines) {
            ccEvent.text = convertToHtml(lines.join(" "));
            events.push(ccEvent);
            ccAdded = true;
            lines = [];
            ccEvent = new _Event();
          }
          if (splitOnComma && word.includes(",")) {
            endEventFlag = true;
          }
          if (splitOnPunctuation && word.match(/\.|\?|\!/g)) {
            endEventFlag = true;
          }
          if (endEventFlag && (line.length > 0 || lines.length > 0)) {
            if (line.length > 0) {
              lines.push(line);
              line = "";
            }
            ccEvent.text = convertToHtml(lines.join(" "));
            events.push(ccEvent);
            ccAdded = true;
            lines = [];
            ccEvent = new _Event();
            endEventFlag = false;
          }
        }
        if (line.length > 0) {
          lines.push(line);
          ccEvent.text = convertToHtml(lines.join(" "));
          events.push(ccEvent);
        } else if (lines.length > 0) {
          ccEvent.text = convertToHtml(lines.join(" "));
          events.push(ccEvent);
        }
      }
    }
    let currentTime = 0;
    events.forEach((ev, evIndex, evs) => {
      let text = convertToPlainText(ev.text, "");
      let characters = text.length;
      if (characters === 0) {
        return;
      }
      let duration = Math.max(0.5, characters / cps);
      evs[evIndex].start = currentTime;
      evs[evIndex].end = currentTime + duration;
      currentTime += duration;
    });

    // console.log(events);
    return events;
  },
  encode: function (eventGroup, options) {
    let output = "",
      paragraphs = [],
      sentences = [],
      speaker = false;
    let encodingOptions = getFormatOptions(options.formatOptions);
    let encodeFormatting = encodingOptions["Encode Formatting"];
    let includeSpeakerName = encodingOptions["Include Speaker Name"] || "no";
    let includeTimestamp = encodingOptions["Include Timestamp"] || "no";
    let maxWords = encodingOptions["Max Words"] ? encodingOptions["Max Words"] : 999999999;
    let prevSpeakerName = "";
    let currentWordCount = 0;
    eventGroup.events.forEach((event, index, events) => {
      let eventText = encodeFormatting ? convertToPlainTextCustom(event.text, " ", false) : convertToPlainText(event.text, " ");
      let speakerName = (event.speakers && event.speakers.length > 0 ? event.speakers[0].name || event.speakers[0] : "") ?? "";

      //Text is made up of the Event Prefix (Which we do some replacements on for variables), Event Text, and the Event Suffix.
      let sentenceText = (encodingOptions["Event Prefix"] ? encodingOptions["Event Prefix"].replace("$id", index) : "").replace("$speaker", speakerName) + eventText + (encodingOptions["Event Suffix"] ? encodingOptions["Event Suffix"] : "");

      // Count words in the current sentence
      let wordCount = sentenceText.trim().split(/\s+/).filter(w => w.length > 0).length;
      if (includeSpeakerName === "yes" && speakerName !== prevSpeakerName || index > 0 && encodingOptions["Split On Event Gap"] && event.start >= events[index - 1].end + parseFloat(encodingOptions["Split On Event Gap"])) {
        if (includeSpeakerName === "yes") {
          sentenceText = speakerName + ":\n" + sentenceText;
        }
        if (includeTimestamp === "yes") {
          sentenceText = tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame) + "\t" + sentenceText;
        }
        prevSpeakerName = speakerName;
        paragraphs.push(sentences.join(" "));
        sentences = [sentenceText];
        currentWordCount = wordCount;
      } else if (currentWordCount + wordCount > maxWords && sentences.length > 0) {
        // Start a new paragraph if adding this sentence would exceed maxWords
        if (includeTimestamp === "yes") {
          sentenceText = tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame) + "\t" + sentenceText;
        }
        paragraphs.push(sentences.join(" "));
        sentences = [sentenceText];
        currentWordCount = wordCount;
      } else {
        if (includeTimestamp === "yes" && index === 0) {
          sentenceText = tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame) + "\t" + sentenceText;
        }
        sentences.push(sentenceText);
        currentWordCount += wordCount;
      }
    });
    if (sentences.length > 0) {
      paragraphs.push(sentences.join(" "));
    }

    // Post-process paragraphs to fix orphaned sentences
    // Find the last period in the paragraph and check if there are fewer characters after it than before it
    // If so, consider it an orphan sentence and move those words to the next paragraph
    for (let i = 0; i < paragraphs.length - 1; i++) {
      if (!paragraphs[i + 1] || paragraphs[i].trim() === "" || paragraphs[i + 1].trim() === "") {
        continue; // Skip empty paragraphs
      }
      let currentParagraph = paragraphs[i];
      let nextParagraph = paragraphs[i + 1];

      // Find the last period in the current paragraph
      let lastPeriodIndex = currentParagraph.lastIndexOf(".");
      if (lastPeriodIndex !== -1) {
        // Count characters before and after the last period
        let charsBeforePeriod = lastPeriodIndex;
        let charsAfterPeriod = currentParagraph.length - lastPeriodIndex - 1;

        // If there are fewer characters after the period than before, it's an orphan sentence
        if (charsAfterPeriod > 0 && charsAfterPeriod < charsBeforePeriod) {
          // Extract the orphaned text after the last period
          let orphanedText = currentParagraph.substring(lastPeriodIndex + 1).trim();
          if (orphanedText.length > 0) {
            // Remove the orphaned text from current paragraph (keep the period)
            paragraphs[i] = currentParagraph.substring(0, lastPeriodIndex + 1).trim();

            // Add it to the beginning of next paragraph
            if (includeTimestamp === "yes") {
              let tabIndex = paragraphs[i + 1].indexOf("\t");
              if (tabIndex !== -1) {
                paragraphs[i + 1] = paragraphs[i + 1].substring(0, tabIndex + 1) + orphanedText + " " + paragraphs[i + 1].substring(tabIndex + 1);
              } else {
                paragraphs[i + 1] = orphanedText + " " + nextParagraph;
              }
            } else {
              paragraphs[i + 1] = orphanedText + " " + nextParagraph;
            }
          }
        }
      }
    }
    output = paragraphs.join("\n\n");

    //Remove Spaces at the beginning of a new line
    output = output.replace(/^[ \t]+/gm, '');
    // console.log(output);
    return output.trim();
  },
  preProcess: {
    encode: function (eventGroup) {
      eventGroup.events = eventGroup.events.filter(event => {
        return stripTags(event.text).trim() !== "";
      });
      return eventGroup;
    },
    decode: function (input) {
      return input;
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup, options) {
      return eventGroup;
    }
  }
};